$(document).ready(function () {
  function generateUniqueId() {
    return Math.random().toString(36).substr(2, 9);
  }

  function checkDeviceActive(mainPosDeviceId) {
    return new Promise((resolve, reject) => {
      const pingId = generateUniqueId();
      const pingData = {
        type: "ping_device",
        target_device_id: mainPosDeviceId,
        sender_id: pingId,
      };
      window.globalSocket.send(JSON.stringify(pingData));

      let timeout = setTimeout(() => {
        window.globalSocket.removeEventListener("message", onPongHandler);
        resolve(false);
      }, 5000);

      const onPongHandler = function (event) {
        try {
          const response = JSON.parse(event.data);
          if (
            response.type === "pong" &&
            response.from_device_id === mainPosDeviceId &&
            response.original_sender === pingId
          ) {
            clearTimeout(timeout);
            window.globalSocket.removeEventListener("message", onPongHandler);
            resolve(true);
          }
        } catch (e) {
          console.error("❌ Error parsing pong:", e);
        }
      };
      window.globalSocket.addEventListener("message", onPongHandler);
    });
  }

  function waitForPrintConfirmation(deviceId, button, buttonText) {
    return new Promise((resolve) => {
      const timeout = setTimeout(() => {
        window.globalSocket.removeEventListener(
          "message",
          onConfirmationHandler
        );
        button.prop("disabled", false);
        button.html(buttonText);
        const errorMessage = $("#web-print-error-container").data(
          "print-failed"
        );
        const alertHtml = getAlertHtml(errorMessage, "danger");
        $("#web-print-error-container").html(alertHtml);
        resolve(false);
      }, 10000);

      const onConfirmationHandler = function (event) {
        try {
          const response = JSON.parse(event.data);

          if (
            response.type === "web_print_completed" &&
            response.deviceId === deviceId
          ) {
            clearTimeout(timeout);
            window.globalSocket.removeEventListener(
              "message",
              onConfirmationHandler
            );

            if (response.orderIds.length == 0) {
              const errorMessage = $("#web-print-error-container").data(
                "print-failed"
              );
              const alertHtml = getAlertHtml(errorMessage, "danger");
              $("#web-print-error-container").html(alertHtml);
            }

            button.prop("disabled", false);
            button.html(buttonText);
            resolve(true);
          }
        } catch (e) {
          button.prop("disabled", false);
          button.html(buttonText);

          const errorMessage = $("#web-print-error-container").data(
            "print-failed"
          );
          const alertHtml = getAlertHtml(errorMessage, "danger");
          $("#web-print-error-container").html(alertHtml);
        }
      };

      document.globalSocket.addEventListener("message", (event) => {
        onConfirmationHandler(event);
      });
    });
  }

  $(document).on("click", ".print-order-from-web", function (event) {
    event.preventDefault();
    const button = $(this);
    const buttonText = button.html();

    const locationId = button.data("location-id");
    const orderData = button.data("order-data");
    const mainPosDeviceId = button.data("main-pos-id");
    const deviceId = localStorage.getItem("deviceID") || "unknown_device";
    const receiptType = button.attr("data-receipt-type") || "";

    $("#web-print-error-container").html("");

    if (window.ReactNativeWebView) {
      if (receiptType == "advance_receipt") {
        passDataToWebView(
          event,
          "advance_receipt",
          orderData.orderProducts,
          orderData.ipAddress,
          orderData.printerType,
          orderData.organizer,
          deviceId
        );
      } else {
        passDataToWebView(
          event,
          "web_print_order",
          [orderData],
          null,
          null,
          null,
          null,
          deviceId
        );
      }
    } else {
      button.prop("disabled", true);
      button.html('<div class="loader"></div>');
      checkDeviceActive(mainPosDeviceId)
        .then(function (isActive) {
          if (isActive) {
            let socketData = {};
            if (receiptType == "advance_receipt") {
              socketData = {
                type: "advance_receipt",
                orderProducts: orderData.orderProducts,
                ipAddress: orderData.ipAddress,
                printerType: orderData.printerType,
                organizer: orderData.organizer,
                main_pos_device_id: mainPosDeviceId,
                requested_device_id: deviceId,
              };
            } else {
              socketData = {
                type: "web_print_order",
                location_id: locationId,
                main_pos_device_id: mainPosDeviceId,
                order_data: orderData,
                requested_device_id: deviceId,
              };
            }

            window.globalSocket.send(JSON.stringify(socketData));

            waitForPrintConfirmation(deviceId, button, buttonText);
          } else {
            button.prop("disabled", false);
            button.html(buttonText);
            const errorMessage = $("#web-print-error-container").data(
              "main-pos-unavailable"
            );
            const alertHtml = getAlertHtml(errorMessage, "danger");
            $("#web-print-error-container").html(alertHtml);
          }
        })
        .catch(function (error) {
          button.prop("disabled", false);
          button.html(buttonText);
          const errorMessage = $("#web-print-error-container").data(
            "main-pos-unavailable"
          );
          const alertHtml = getAlertHtml(errorMessage, "danger");
          $("#web-print-error-container").html(alertHtml);
        });
    }
  });
});
